import { Button } from '@/components/ui/button'
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select'

const PAGE_SIZES = [10, 25, 50, 100]

interface TablePaginationProps {
  current: number
  pageCount: number
  pageSize: number
  total: number
  onPageChange: (page: number) => void
  onPageSizeChange: (size: number) => void
}

export function TablePagination({
  current, pageCount, pageSize, total,
  onPageChange, onPageSizeChange,
}: TablePaginationProps) {
  return (
    <div className="flex items-center justify-between text-sm text-muted-foreground">
      <div className="flex items-center gap-2 text-xs">
        <span>Rows per page:</span>
        <Select
          value={String(pageSize)}
          onValueChange={(v) => { onPageSizeChange(Number(v)); onPageChange(1) }}
        >
          <SelectTrigger className="h-7 w-16 text-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZES.map((s) => (
              <SelectItem key={s} value={String(s)} className="text-xs">{s}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <span>· {total.toLocaleString()} total</span>
      </div>
      <div className="flex items-center gap-2 text-xs">
        <Button
          variant="outline" size="sm" className="h-7 px-2 text-xs"
          onClick={() => onPageChange(current - 1)}
          disabled={current <= 1}
        >
          ← Prev
        </Button>
        <span className="font-medium text-foreground">{current} of {pageCount}</span>
        <Button
          variant="outline" size="sm" className="h-7 px-2 text-xs"
          onClick={() => onPageChange(current + 1)}
          disabled={current >= pageCount}
        >
          Next →
        </Button>
      </div>
    </div>
  )
}
